/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Street/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Street({
  children,
  viewPath = "/DesignSystem/DataVaxiomInsuranceCarrierForm/Address/Street",
  onChange
  
}) {
let carrierPostalAddressAddressLine1ValueData = fromData.useDataValue({ viewPath,
context: 'carrier',
path: 'postal_address.address_line1',
})
let carrierPostalAddressAddressLine1ChangeData = fromData.useDataChange({ viewPath,
context: 'carrier',
path: 'postal_address.address_line1',
})
let onChooseAddress = fromHelpers.useOnChooseAddress({
  children,
  viewPath,
  onChange
  
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="carrier.postal_address.address_line1"
 value={carrierPostalAddressAddressLine1ValueData}
 onChange={carrierPostalAddressAddressLine1ChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Street Address"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 focusOnDownArrowKey={true}
 onChooseAddress={onChooseAddress}
 type="address"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}